'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _Menu = require('./Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _utils = require('./utils');

var _reactRouter = require('react-router');

var _lodashCompat = require('lodash-compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var UNIT_PADDING = 10;

/**
 * 侧边导航栏
 *
 */
var AsideNav = (_temp = _class = function (_M$BaseComponent) {
  _inherits(AsideNav, _M$BaseComponent);

  function AsideNav(props) {
    _classCallCheck(this, AsideNav);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AsideNav).call(this, props));

    Object.assign(_this.state, {
      openKeys: [], //当前展开的结点
      selectedKeys: [] }, _this._parseMenu(props.menu, props.activeCode));
    return _this;
  }

  _createClass(AsideNav, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newState = {};
      if (nextProps.hasOwnProperty('menu') || nextProps.hasOwnProperty('activeCode')) {
        var obj = this._parseMenu(nextProps.menu, nextProps.activeCode);

        //FIXME 暂时这么处理，和以前的展开合并，让展开选项继续展开
        var openKeys = this.state.openKeys;

        var arr = (0, _lodashCompat.union)(openKeys, obj.openKeys);
        //去除menu里不存在的key
        arr = arr.filter(function (code) {
          return nextProps.menu.has(code);
        });
        obj.openKeys = arr;

        Object.assign(newState, obj);
      }
      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var theme = _props.theme;
      var keepNavAside = _props.keepNavAside;

      var basicPrefixCls = prefixCls + '-aside';
      var _state = this.state;
      var openKeys = _state.openKeys;
      var selectedKeys = _state.selectedKeys;
      var subMenuItems = _state.subMenuItems;

      return _react2.default.createElement(
        'div',
        { className: _util2.default.classNames(basicPrefixCls + ' ' + basicPrefixCls + '--' + theme, {
            'nav-aside': keepNavAside
          }) },
        _react2.default.createElement(
          'div',
          { className: basicPrefixCls + '__inner' },
          _react2.default.createElement(
            'div',
            { className: basicPrefixCls + '__nav' },
            _react2.default.createElement(
              _Menu2.default,
              { prefixCls: basicPrefixCls,
                openKeys: openKeys,
                selectedKeys: selectedKeys,
                onOpenChange: this._handleOpenChange,
                onSelect: this._handleSelect },
              subMenuItems
            )
          )
        )
      );
    }
  }, {
    key: '_parseMenu',
    value: function _parseMenu(menu, activeCode) {
      var _this2 = this;

      if (!menu || menu.size == 0) return;

      var result = {};

      var activeNode = menu.get(activeCode);
      if (activeNode) {
        var selectedKeys = [activeCode];
        //默认展开的结点，从子结点向上找到所有的父级
        var openKeys = [];
        var curNode = menu.get(activeNode.parent);
        while (curNode) {
          openKeys.unshift(curNode.code);
          curNode = menu.get(curNode.parent);
        }
        Object.assign(result, { openKeys: openKeys, selectedKeys: selectedKeys });
      }

      //按层级分类
      var groupMenu = menu.groupBy(function (item) {
        return item.level;
      });
      var keys = groupMenu.keySeq().toArray();
      var minLayer = Math.min.apply(Math, _toConsumableArray(keys));
      var subMenuItems = groupMenu.get(minLayer).map(function (item) {
        return _this2._renderMenuItems(item.code, menu);
      }).toArray();

      Object.assign(result, { subMenuItems: subMenuItems });
      return result;
    }
  }, {
    key: '_renderMenuItems',
    value: function _renderMenuItems(code, data) {
      var _this3 = this;

      var node = data.get(code);
      if (node.type == 'folder') {
        return _react2.default.createElement(
          _Menu2.default.SubMenu,
          { key: node.code,
            eventKey: node.code,
            label: node.label,
            icon: node.icon,
            level: node.level + 1,
            node: node },
          node.children.map(function (code) {
            return _this3._renderMenuItems(code, data);
          })
        );
      } else {
        var urlFor = this.props.urlFor;

        var content = void 0;
        if (node.type == 'link') {
          content = _react2.default.createElement(
            'a',
            { href: node.url, target: node.target || '_blank',
              className: 'menu-item-link',
              style: {
                paddingLeft: (node.level + 1) * UNIT_PADDING + UNIT_PADDING - AsideNav.BORDER_LEFT_WIDTH,
                borderLeftWidth: AsideNav.BORDER_LEFT_WIDTH
              } },
            _react2.default.createElement(
              'span',
              { className: 'menu-item-link__icon' },
              (0, _utils.buildIcon)(node.icon)
            ),
            _react2.default.createElement(
              'span',
              null,
              node.label
            )
          );
        } else {
          content = _react2.default.createElement(
            _reactRouter.Link,
            { to: urlFor(node.code),
              className: 'menu-item-link',
              style: {
                paddingLeft: (node.level + 1) * UNIT_PADDING + UNIT_PADDING - AsideNav.BORDER_LEFT_WIDTH,
                borderLeftWidth: AsideNav.BORDER_LEFT_WIDTH
              } },
            _react2.default.createElement(
              'span',
              { className: 'menu-item-link__icon' },
              (0, _utils.buildIcon)(node.icon)
            ),
            _react2.default.createElement(
              'span',
              null,
              node.label
            )
          );
        }
        return _react2.default.createElement(
          _Menu2.default.Item,
          { key: node.code,
            eventKey: node.code,
            level: node.level + 1,
            node: node },
          content
        );
      }
    }
  }, {
    key: '_handleOpenChange',
    value: function _handleOpenChange(openKeys) {
      this.setState({ openKeys: openKeys });
    }
  }, {
    key: '_handleSelect',
    value: function _handleSelect(key, node, selectedKeys) {
      if (node.type != 'link') {
        this.setState({ selectedKeys: selectedKeys });
      } else {
        //重刷界面
        this.forceUpdate();
      }
    }
  }]);

  return AsideNav;
}(_util2.default.BaseComponent), _class.BORDER_LEFT_WIDTH = 3, _temp);
exports.default = AsideNav;